import { Stack, useTheme } from "@mui/material";
import { Button } from "components";
import { useAtomValue, useSetAtom } from "jotai";
import React, { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { ChecklistDrawerContent } from "shared/features/check-list/ChecklistDrawerContent";
import { checklistData, setChecklistData } from "../store/newTicketStore";

export const ChecklistComponent = () => {
  const checklistArray = useAtomValue(checklistData);
  const setChecklistArray = useSetAtom(setChecklistData);
  const { setValue, getValues } = useFormContext();
  const [isLibraryOpen, setIsLibraryOpen] = useState<boolean>(false);

  const contentRef = useRef<any>(null);
  const theme = useTheme();

  const onImportClick = () => {
    const data = contentRef?.current?.submit?.();
    if (data && data?.length > 0) {
      const newItems: Array<any> = [];

      data.map((item: any) => {
        newItems.push(...item.items);
      });

      setChecklistArray({ items: newItems });
      setValue("checklist", newItems);
    }

    if (isLibraryOpen) {
      setIsLibraryOpen(false);
      return;
    }
  };

  const saveToStore = (data: any) => {
    const checklistArr = data.map(
      (checklist: Record<string, any>) => checklist.data,
    );
    setChecklistArray({ items: checklistArr });
    setValue("checklist", checklistArr);
  };
  return (
    <Stack
      sx={{
        position: "relative",
        padding: "0px",
        overflow: "hidden",
        height: "100%",
      }}
    >
      <Stack sx={{ flexGrow: 1, overflowY: "scroll", padding: "16px" }}>
        <ChecklistDrawerContent
          ref={contentRef}
          checklist={checklistArray}
          currentContent={isLibraryOpen ? "library" : "list"}
          onImportClick={() => setIsLibraryOpen(true)}
          source={"other"}
          isNew={true}
          onChange={(data: any) => {
            if (data && data.items) {
              saveToStore(data.items);
            }
          }}
        />
      </Stack>
      {isLibraryOpen && (
        <Stack
          direction={"row"}
          gap={"8px"}
          sx={{
            justifyContent: "flex-end",
            padding: "8px 16px",
            borderTop: `1px solid ${theme.palette.neutral["015"]}`,
          }}
        >
          <Button variant="secondary" onClick={() => setIsLibraryOpen(false)}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onImportClick}>
            import
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
